import {
  RAMOS_HAS_ERRORED,
  SET_DATA_RAMOS,
  RAMOS_LOADING,
  SUCURSAL_HAS_ERRORED,
  SET_DATA_SUCURSAL,
  SUCURSAL_LOADING,
  DISCLAIMER_HAS_ERRORED,
  DISCLAIMER_IS_LOADING,
  UPDATE_DISCLAIMER_OK,
  LIMPIAR_DISCLAIMER,
  UPDATE_SUCURSAL_SELECCIONADA
} from "../actions/aRamos";

const initialState = {
  ramosisLoading: false,
  ramosError: "",
  DataRamos: [],
  sucursalisLoading: false,
  sucursalError: "",
  DataSucursales: [],
  sucursalSelecionadaAsesor:""
};

const datosRamos = (state = initialState, action) => {
  switch (action.type) {
    case RAMOS_HAS_ERRORED:
      return {
        ...state,
        ramosisLoading: false,
        ramosError: action.ramosError
      };

    case RAMOS_LOADING:
      return {
        ...state,
        ramosisLoading: true,
        ramosError: ""
      };

    case SET_DATA_RAMOS:
      return {
        ...state,
        DataRamos: action.setDataRamos,
        ramosisLoading: false,
        ramosError: ""
      };

    default:
      return state;
  }
};

export default datosRamos;

export const datosSucursales = (state = initialState, action) => {
  switch (action.type) {
    case SUCURSAL_HAS_ERRORED:
      return {
        ...state,
        sucursalisLoading: false,
        sucursalError: action.sucursalError
      };

    case SUCURSAL_LOADING:
      return {
        ...state,
        sucursalisLoading: true,
        sucursalError: ""
      };

    case UPDATE_SUCURSAL_SELECCIONADA:
      return{
        ...state,
        sucursalSelecionadaAsesor:action.payload
      }

    case SET_DATA_SUCURSAL:
      return {
        ...state,
        DataSucursales: action.setDataSucursal,
        sucursalisLoading: false,
        sucursalError: ""
      };
    default:
      return state;
  }
};

const initialState4 = {
  disclaimerError: false,
  disclaimerLoading: false,
  updateDisclaimerOK: false
};
export const datosActualizarDisclaimer = (state = initialState4, action) => {
  switch (action.type) {
    case DISCLAIMER_HAS_ERRORED:
      return {
        ...state,
        disclaimerError: true,
        disclaimerLoading: false
      };
    case DISCLAIMER_IS_LOADING:
      return {
        ...state,
        disclaimerLoading: true,
        disclaimerError: false
      };
    case UPDATE_DISCLAIMER_OK:
      return {
        ...state,
        disclaimerLoading: false,
        updateDisclaimerOK: action.payload
      };
    case LIMPIAR_DISCLAIMER:
      return {
        ...state,
        disclaimerLoading: false,
        updateDisclaimerOK: false,
        disclaimerError: false
      };
    default:
      return state;
  }
};
